import styled from 'styled-components';
import { GYPSUM } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const Animation = styled.div.withConfig({
  displayName: "EPAnimatedSearchBox__Animation",
  componentId: "sc-5wj272-0"
})(["animation:appear 300ms ease-out;@keyframes appear{0%{opacity:0;transform:scale(0.95);}100%{opacity:1;transform:scale(1);}}"]);
const SearchBox = styled.div.withConfig({
  displayName: "EPAnimatedSearchBox__SearchBox",
  componentId: "sc-5wj272-1"
})(["border-radius:14px;width:580px;background-color:", ";box-shadow:0 10px 25px -5px rgb(0 0 0 / 10%),0 5px 10px -5px rgba(0,0,0,0.04),inset 0 1px 0 0 rgb(0 0 0 / 1%),inset 0 0 0 1px rgb(0 0 0 / 2%);transition:max-height 300ms ease-out;overflow:hidden;&.compact{max-height:48px;}&.expanded{max-height:600px;}"], GYPSUM);
const EPAnimatedSearchBox = ({
  className,
  children
}) => {
  return /*#__PURE__*/_jsx(Animation, {
    children: /*#__PURE__*/_jsx(SearchBox, {
      className: className,
      children: children
    })
  });
};
export default EPAnimatedSearchBox;